import { useEffect, useRef, useState } from "react";

// Tracks whether the mouse is "active" (moved recently) so the UI
// can fade in/out per spec section #3.

const IDLE_MS = 2500;

export function useMouseActivity(): boolean {
  const [active, setActive] = useState(true);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    const reset = () => {
      setActive(true);
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setActive(false), IDLE_MS);
    };

    const onLeave = () => {
      setActive(false);
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };

    // Initial state: show UI for a moment, then hide
    reset();

    window.addEventListener("mousemove", reset);
    window.addEventListener("mousedown", reset);
    window.addEventListener("touchstart", reset);
    window.addEventListener("wheel", reset, { passive: true });
    window.addEventListener("keydown", reset);
    document.addEventListener("mouseleave", onLeave);

    return () => {
      window.removeEventListener("mousemove", reset);
      window.removeEventListener("mousedown", reset);
      window.removeEventListener("touchstart", reset);
      window.removeEventListener("wheel", reset);
      document.removeEventListener("mouseleave", onLeave);
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  return active;
}